import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { useStripeCheckout } from "@/hooks/useStripeCheckout";

export default function CheckoutPending() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { openCheckout, checkoutElement } = useStripeCheckout();

  const signOut = async () => {
    await supabase.auth.signOut();
    navigate("/", { replace: true });
  };

  const buy = () => {
    openCheckout({
      priceId: "trends_discovery_lifetime_39",
      customerEmail: user?.email,
      userId: user?.id ?? "",
      returnUrl: `${window.location.origin}/checkout/success?session_id={CHECKOUT_SESSION_ID}`,
    });
  };

  return (
    <>
      <Helmet>
        <title>License required — Trends Discovery</title>
        <meta name="description" content="The Trends Discovery dashboard requires an active lifetime license. Complete checkout to unlock the full trend feed and launch blueprints." />
        <link rel="canonical" href="https://trendsdiscovery.com/checkout/pending" />
        <meta property="og:title" content="License required — Trends Discovery" />
        <meta property="og:url" content="https://trendsdiscovery.com/checkout/pending" />
        <meta name="robots" content="noindex" />
      </Helmet>
    <div className="min-h-screen grid place-items-center px-4 bg-hero-radial text-center">
      <div className="max-w-lg">
        <div className="font-mono text-xs text-accent mb-3">// NO ACTIVE LICENSE</div>
        <h1 className="font-display text-4xl font-bold">License required</h1>
        <p className="mt-4 text-muted-foreground">
          The dashboard is reserved for lifetime license holders. Grab access for a one-time
          payment and you'll be in immediately.
        </p>
        {user?.email && (
          <p className="mt-3 font-mono text-xs text-muted-foreground">
            signed in as {user.email}
          </p>
        )}
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button variant="hero" size="lg" onClick={buy}>
            Get lifetime access — $39
          </Button>
          <Button variant="outline" size="lg" asChild>
            <Link to="/">Back to home</Link>
          </Button>
          {user && (
            <Button variant="ghost" size="lg" onClick={signOut}>
              Sign out
            </Button>
          )}
        </div>
      </div>
      {checkoutElement}
    </div>
    </>
  );
}
